import React, { Component } from "react";
import {  Row, Col, Button, ListGroup, Form, Alert, Modal } from "react-bootstrap";

import "containers/common/List.css";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import DatePicker from "react-datepicker";
import Select from 'react-select';
import Moment from "moment";


export default class BuildingGradeList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,           
            filter: {},
            dataSet: "buildingGrades",
            dataRecord: "buildingGrades",
            dataSetPrimaryKey: "building_grade_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {        
        if (!this.props.isAuthenticated) { // if false
            return;
        }        

        this.setState({ isLoading: false });      
    }
    



    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }





    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        if (event.detail !== 0) {
            let data = [...this.props.data];
            var r = window.confirm("Are you sure you want to delete this record?");
            if (r === true) {
                console.log(cellInfo);

                data[cellInfo.index].archived_date = new Date();
                await this.handleDataSave(data[cellInfo.index]).then((result) => {
                    data.splice(cellInfo.index, 1);
                    this.props.updateTableState(data, this.state.dataSet);
                }
                )
            };
        }
    };


    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(event);
        data[cellInfo.index][cellInfo.column.id] = dt.toLocaleDateString('en-AU',options);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }
    
 

    handleBuildingGradeSourceChange = (cellInfo, event) => {
        let data = [...this.props.data];
        console.log(event);
        data[cellInfo.index][cellInfo.column.id] = event.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleBuildingGradeChange = (cellInfo, event) => {
        let data = [...this.props.data];
        console.log(event);
        data[cellInfo.index][cellInfo.column.id] = event.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
                        console.log(validation[0]);
                        if (validation[0] === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                            
                        }
                    }
                    else {
                        this.setState({ errorMessage: validation[1] });
                        this.setState({ showAlert: true });
                        return;
                    }
                    }//is modified

                }//has modified flag
            
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        if (data[0].hasOwnProperty("source_date")) {
            data.sort(function (a, b) { return a.source_date - b.source_date });
        }
        if (data[0].hasOwnProperty("override")) {
            data.sort(function (a, b) { return  (a.override === b.override)? 0 : a.override? -1 : 1 });
        }
        this.props.updateTableState(data, this.state.dataSet);


    }



    renderEditable = cellInfo => {
       // if(cellInfo.original.source_method=="KEYED");
        //{
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];
        if (cellInfo.column.id == "override") {
            return (<Form.Check checked={cellValue}
                onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                label=""
                type="checkbox"
                onBlur={this.handleSave.bind(null, cellInfo)}

            />
            );


        }

        if (cellInfo.column.id == "building_grade_source_code") {
            if (cellValue) {
                return (<div><Select
                    value={{ value: cellValue, label: this.props.buildingGradeSourceOptions.find(o => o.value === cellValue).label }}
                    onChange={this.handleBuildingGradeSourceChange.bind(null, cellInfo)}
                    options={this.props.buildingGradeSourceOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                /></div>
                );
            }
            else {
                return (<div><Select

                    onChange={this.handleBuildingGradeSourceChange.bind(null, cellInfo)}
                    options={this.props.buildingGradeSourceOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                /></div>
                );
            }
        }
        
        if (cellInfo.column.id == "building_grade_code") {
            if (cellValue) {
                return (<div><Select
                    value={{ value: cellValue, label: this.props.buildingGradeOptions.find(o => o.value === cellValue).label }}
                    onChange={this.handleBuildingGradeChange.bind(null, cellInfo)}
                    options={this.props.buildingGradeOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                /></div>
                );
            }
            else {
                return (<div><Select

                    onChange={this.handleBuildingGradeChange.bind(null, cellInfo)}
                    options={this.props.buildingGradeOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                /></div>
                );
            }
        }
           
            
        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        style={{
                            textAlign: "center"
                        }}
                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            if (cellInfo.column.id == "notes") {
                            return (
                                
                                    <input
                                        onChange={this.handleInputChange.bind(null, cellInfo)}
                                        onBlur={this.handleSave.bind(null, cellInfo)}
                                        type="text"
                                        className="no-border form-control"
                                        value={cellValue!=null? cellValue:""}
                                        class="internal"
                                    />
                            );
                            }
                                else{
                                    return (
                                    <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                                );
                                }
                            
                        }

        }
    }

    addRecord = async event => {
        let data = [...this.props.data];

        //Minimum record to create (all not nulls populated)
        data.push({
            property_id: this.props.filter.propertyid,
            building_grade_code: null,
            building_grade: null,
            building_grade_source_code: "LIST",
            building_grade_source: "Sale/Lease Listing", 
            source_method: "KEYED",
            source_date: new Date(),
            override: false,
            notes: "",
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }




    renderTable(data) {
        const columns = [

            {
                id: 'building_grade_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'building_grade_id'

            }, {
                id: 'building_grade_code',
                Header: 'Building Grade',
                accessor: 'building_grade_code',
                Cell: this.renderEditable

            }, {
                id: 'building_grade_source',
                Header: 'Building Grade Source',
                accessor: 'building_grade_source'

            },
            {
                id: 'source_date',
                Header: 'Source Date',
                accessor: 'source_date',
                Cell: this.renderEditable

            },
            {
                id: 'override',
                Header: 'Overide',
                accessor: 'override',
                Cell: this.renderEditable,
                style: { textAlign: "center" }

            },
            {
                id: 'notes',
                Header: 'Notes',
                accessor: 'notes',
                Cell: this.renderEditable

            },
            {
                id: 'source_method',
                Header: 'Source Method',
                accessor: 'source_method'

            },
            {
                Header: '',
                accessor: 'building_grade_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }



    }


    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>

                    i !== 0
                        ?
                        <ListGroup.Item key={i} as="a" header={d.building_grade_code}>
                            {d.building_grade_code + " Grade - " + Moment(d.source_date).local().format("DD-MM-YYYY")
                       
                        }
                        </ListGroup.Item>

                        : ""
            );
        }
    }

    
    renderComponent() {
        return (
            <div className="Buildinggrades">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.props.controlType === "table" && <Row className="show-Container">
                    <Col className="text-right" >

                        <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>

                    </Col>
                </Row>}

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : this.renderList(this.props.data)}
                        </Col>
                    </Row>
         

            </div>
        );
    }
  render() {
    return (

        <div className="BuildingGradeList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
